export default "__VITE_ASSET__4dfabaf3__"